{
  "jump_beef": {
    "displayName": "JUMP BEEF",
    "pakProvider": "jump-beef-pak",
    "loadingPhoto": null,
    "admission": "playable",
    "mode": "custom",
    "navigation": null,
    "logicalPath": "maps/jump_beef.bsp",
    "download": {
      "url": "https://static.tempus2.xyz/tempus/server/maps/jump_beef.bsp.bz2",
      "compression": "bzip2",
      "encodedByteLength": 12154530,
      "encodedSha256": "b8d257bc568964ecf9c5e9dc2c4015bcbac204d7fb3e54ee2d92b0de8b61292c",
      "decodedByteLength": 33379388,
      "decodedSha256": "b2e22010b56aa03387c76396a55f2fb83cdeb72a9562ed16cfb656a747e58959"
    }
  },
  "pl_upward": {
    "displayName": "Upward",
    "pakProvider": "pl_upward-pak",
    "loadingPhoto": null,
    "admission": "playable",
    "mode": "payload",
    "navigation": "local",
    "logicalPath": "maps/pl_upward.bsp",
    "installed": {
      "contentBuild": "24245096",
      "provider": "game-09-tf",
      "byteLength": 25446018,
      "sha256": "15cbf91981b0d9902c645d1992d196b7e630742aa85111ed834d231f3c3a5709"
    }
  },
  "ctf_2fort": {
    "displayName": "2Fort",
    "pakProvider": "ctf_2fort-pak",
    "loadingPhoto": {
      "material": { "byteLength": 126, "sha256": "6c1228fd96a0f6029a924ea19d7801c9681db084742db8583e8f3d425056aac4" },
      "texture": { "byteLength": 349784, "sha256": "1ec1d0a675522d3245e72817d83f9292ea9c60bcfde8d40bfe1b38eff2c889ad" }
    },
    "admission": "playable",
    "mode": "capture-the-flag",
    "navigation": "local",
    "logicalPath": "maps/ctf_2fort.bsp",
    "installed": {
      "contentBuild": "24245096",
      "provider": "game-09-tf",
      "byteLength": 22751863,
      "sha256": "cbd191411c0be57099da73458167001ec80d58bf37c71cb3c36b2911b6e80fd7"
    }
  },
  "cp_dustbowl": {
    "displayName": "Dustbowl",
    "pakProvider": "cp_dustbowl-pak",
    "loadingPhoto": {
      "material": { "byteLength": 128, "sha256": "4aad583ae79263f72365353851eb9754b3652034161fc6084867f00e6cc5aa7e" },
      "texture": { "byteLength": 349784, "sha256": "57dc34a7ba72b8917e2c15996890322c4c31694c523d9184fcf11b11bd351559" }
    },
    "admission": "playable",
    "mode": "control-point",
    "navigation": "content",
    "logicalPath": "maps/cp_dustbowl.bsp",
    "installed": {
      "contentBuild": "24245096",
      "provider": "game-09-tf",
      "byteLength": 21945050,
      "sha256": "f2595d3f6af19f21d7beaeed7ecb7a130246a5b934641a44f0f68d54edfc421e"
    }
  },
  "cp_gorge": {
    "displayName": "Gorge",
    "pakProvider": "cp_gorge-pak",
    "loadingPhoto": {
      "material": { "byteLength": 125, "sha256": "b0cfc7e17d8f9be1fb12a6f9496a9dc0e961da98d1e459486e4bed46c8456085" },
      "texture": { "byteLength": 349784, "sha256": "062f6fc6ba828069b6e111c8c5b8d2b7d0314c7fe9d56f741b385b142fc26437" }
    },
    "admission": "playable",
    "mode": "control-point",
    "navigation": "content",
    "logicalPath": "maps/cp_gorge.bsp",
    "installed": {
      "contentBuild": "24245096",
      "provider": "game-09-tf",
      "byteLength": 50238340,
      "sha256": "94db834e88f98048326513133a8c98178866cef2f72d6406515ed1af0a4a5f46"
    }
  },
  "cp_badlands": {
    "displayName": "Badlands",
    "pakProvider": "cp_badlands-pak",
    "loadingPhoto": {
      "material": { "byteLength": 128, "sha256": "6a45f1211c845f31142ba982d309fcd83998b28b009a9bf31a22632125edeb50" },
      "texture": { "byteLength": 349784, "sha256": "93fabba8582f98ddb430c02aa2271c71ef341e99ed73eec33aa0344cc691dbc5" }
    },
    "admission": "playable",
    "mode": "control-point",
    "navigation": "content",
    "logicalPath": "maps/cp_badlands.bsp",
    "installed": {
      "contentBuild": "24245096",
      "provider": "game-09-tf",
      "byteLength": 25981141,
      "sha256": "872f6e77abda907d095000009cfbe8c50d62d15e304c80c7dc86a6591ebc08e3"
    }
  },
  "cp_granary": {
    "displayName": "Granary",
    "pakProvider": "cp_granary-pak",
    "loadingPhoto": {
      "material": { "byteLength": 127, "sha256": "0cd68c8b8eae2b352744ecc878f75a2a337e89e6b5010b5a0a1e0a0aa59fe157" },
      "texture": { "byteLength": 349784, "sha256": "06c27814d6fcf62ada04195f1917ddfa01c8b09586d9f0afacc91a76e55d278d" }
    },
    "admission": "playable",
    "mode": "control-point",
    "navigation": "content",
    "logicalPath": "maps/cp_granary.bsp",
    "installed": {
      "contentBuild": "24245096",
      "provider": "game-09-tf",
      "byteLength": 60353484,
      "sha256": "6080d8b69cd526aa3e76252d61138ccd4d371953ea0ef2787e5a56bd3399f08d"
    }
  },
  "cp_well": {
    "displayName": "Well",
    "pakProvider": "cp_well-pak",
    "loadingPhoto": {
      "material": { "byteLength": 124, "sha256": "82c576a9b577fc9fce810403c20410afbc1c038c6b3ed0725efd816c29754f4d" },
      "texture": { "byteLength": 349784, "sha256": "4685e3f54cf5591929f11ba1a37a57725667a3d012eadbe1e7650d12c6e24823" }
    },
    "admission": "playable",
    "mode": "control-point",
    "navigation": "local",
    "logicalPath": "maps/cp_well.bsp",
    "installed": {
      "contentBuild": "24245096",
      "provider": "game-09-tf",
      "byteLength": 69715720,
      "sha256": "d66a82edd7aaefe3290bef2d0397d2380f958d5c4e99f4dc57d4d4431a8f92b4"
    }
  },
  "cp_freight_final1": {
    "displayName": "FREIGHT",
    "pakProvider": "cp_freight_final1-pak",
    "loadingPhoto": {
      "material": { "byteLength": 134, "sha256": "34c6ccd4a2c177e24b3e3f82aff8184d763b1ca3d0b5a3b58a49ad41dd6ecde3" },
      "texture": { "byteLength": 349784, "sha256": "705c6434da851a39ae4f73e765aa007ba79f708ed62c1b8c261e91be49936e48" }
    },
    "admission": "playable",
    "mode": "control-point",
    "navigation": "local",
    "logicalPath": "maps/cp_freight_final1.bsp",
    "installed": {
      "contentBuild": "24245096",
      "provider": "game-09-tf",
      "byteLength": 77271944,
      "sha256": "f997458041ce58e0b1c7eaa9bea12bc683552e198d44551f01d45c425868dd86"
    }
  },
  "cp_gullywash_final1": {
    "displayName": "GULLYWASH",
    "pakProvider": "cp_gullywash_final1-pak",
    "loadingPhoto": {
      "material": { "byteLength": 134, "sha256": "0b52ccb300a921eefa1608fac294233a576eaa64241508423a86ff1d2f6d54dc" },
      "texture": { "byteLength": 349784, "sha256": "0bbd3dbdcf7b4ba8d181918ee86209c8e43b0118bd3320365a31ebe6f5d0ffc2" }
    },
    "admission": "playable",
    "mode": "control-point",
    "navigation": "content",
    "logicalPath": "maps/cp_gullywash_final1.bsp",
    "installed": {
      "contentBuild": "24245096",
      "provider": "game-09-tf",
      "byteLength": 24500234,
      "sha256": "6f60fa38954ea1fd104c27eb73a83282ab6ceea02cbcce033999c6b61ced233f"
    }
  },
  "cp_process_final": {
    "displayName": "PROCESS",
    "pakProvider": "cp_process_final-pak",
    "loadingPhoto": {
      "material": { "byteLength": 133, "sha256": "b8da3bfe98c6ead74f4ea0ad000de3c551e17e56dd5fe20287f8a2f31a35fb1b" },
      "texture": { "byteLength": 349784, "sha256": "f0f17e8d8fe521f4de64343176beb5ee98a374cc51a8d4144bf0b96a3304b753" }
    },
    "admission": "playable",
    "mode": "control-point",
    "navigation": "local",
    "logicalPath": "maps/cp_process_final.bsp",
    "installed": {
      "contentBuild": "24245096",
      "provider": "game-09-tf",
      "byteLength": 19794859,
      "sha256": "52c74027ac179b9686af9ce40d7418f08ef6845d945587b4ccae335cf7081a71"
    }
  },
  "koth_viaduct": {
    "displayName": "Viaduct",
    "pakProvider": "koth_viaduct-pak",
    "loadingPhoto": {
      "material": { "byteLength": 129, "sha256": "2f8dddeef0cff874e22ed4b58909fc5bf44b67fa0da9d55f1cd4956d22751ba4" },
      "texture": { "byteLength": 349784, "sha256": "af246c72096fc065b5b5a2c0cd617638f31e783067104315ae7ffde691b1e70a" }
    },
    "admission": "playable",
    "mode": "king-of-the-hill",
    "navigation": "content",
    "logicalPath": "maps/koth_viaduct.bsp",
    "installed": {
      "contentBuild": "24245096",
      "provider": "game-09-tf",
      "byteLength": 41690668,
      "sha256": "b3574e496550311f5036997ed7bf3d1007be7fe28236f8f33a2352fe0518729c"
    }
  },
  "koth_sawmill": {
    "displayName": "SAWMILL",
    "pakProvider": "koth_sawmill-pak",
    "loadingPhoto": {
      "material": { "byteLength": 129, "sha256": "9dedf7d5b5de1ecd8d53910901ae825f5e57390ed15902e4716fffceb2903469" },
      "texture": { "byteLength": 349784, "sha256": "4ea0f6f0bd78decad44faa80d3a8faef18786c356a017add6d6eaad4af4d5383" }
    },
    "admission": "playable",
    "mode": "king-of-the-hill",
    "navigation": "content",
    "logicalPath": "maps/koth_sawmill.bsp",
    "installed": {
      "contentBuild": "24245096",
      "provider": "game-09-tf",
      "byteLength": 27758576,
      "sha256": "3efbcfc7fd6be31e2a6949b1ec51d410072409253dbf230f97054642cc8cc5a3"
    }
  },
  "koth_harvest_final": {
    "displayName": "HARVEST",
    "pakProvider": "koth_harvest_final-pak",
    "loadingPhoto": {
      "material": { "byteLength": 135, "sha256": "f590775acccb6115d8835fed2f1561079cb9791b00bbd3ff8849619271d10cfc" },
      "texture": { "byteLength": 349784, "sha256": "d46cae5b1ee78ad235c71415e6bab2cc1fbd546fbe06ffd2d43a85f86fe1ff1c" }
    },
    "admission": "playable",
    "mode": "king-of-the-hill",
    "navigation": "local",
    "logicalPath": "maps/koth_harvest_final.bsp",
    "installed": {
      "contentBuild": "24245096",
      "provider": "game-09-tf",
      "byteLength": 26691032,
      "sha256": "441e18e3b8053aa55e9ddef7a4bc6681756518045701adee0d13eaf3b052320a"
    }
  },
  "koth_lakeside_final": {
    "displayName": "LAKESIDE",
    "pakProvider": "koth_lakeside_final-pak",
    "loadingPhoto": {
      "material": { "byteLength": 136, "sha256": "8ad219c413a80b63d25e4dae202d4b41fd5a0929ad1188c9dd2d96b37783d7b6" },
      "texture": { "byteLength": 349784, "sha256": "9d7116cf245873ed7a77c966f81b82912d1fcaa53ce62b47445631073f94bf7c" }
    },
    "admission": "playable",
    "mode": "king-of-the-hill",
    "navigation": "content",
    "logicalPath": "maps/koth_lakeside_final.bsp",
    "installed": {
      "contentBuild": "24245096",
      "provider": "game-09-tf",
      "byteLength": 41123424,
      "sha256": "1d9a761337c213122ce98e9e1f79bfc3cb7ec550851c8f0237c4db76f50d7fe7"
    }
  }
}
